import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.ssh.access');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-ssh-access',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.ssh.access/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.ssh-inventory .ssh-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  color: #6366f1;
  text-decoration: none;
}
.ssh-inventory .ssh-key-link {
  color: #4f46e5;
  font-weight: 500;
  text-decoration: none;
}
.ssh-inventory .ssh-key-link:hover {
  text-decoration: underline;
}
.ssh-inventory .access-badge {
  margin: 2px 4px 2px 0;
}
.ssh-inventory .ssh-key-table {
  min-width: 1000px;
}
.ssh-inventory .ssh-fingerprint {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ssh-inventory .ssh-fingerprint-value {
  min-width: 0;
  overflow-wrap: anywhere;
}
.ssh-inventory .ssh-fingerprint-toggle {
  flex-shrink: 0;
  padding: 6px;
}
.ssh-inventory .ssh-fingerprint-toggle i {
  font-size: 16px;
}
.ssh-inventory .ssh-fingerprint-toggle:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: 2px;
}
.ssh-inventory .ssh-explanation {
  line-height: 1.7;
  margin: 16px 0;
}
.ssh-inventory .ssh-detail-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.ssh-inventory .ssh-detail-heading h2 {
  margin-bottom: 8px;
}
.ssh-inventory .ssh-key-metadata {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr);
  gap: 10px;
  margin: 0 0 20px;
}
.ssh-inventory .ssh-key-metadata dt {
  color: #71717a;
  font-weight: 400;
}
.ssh-inventory .ssh-key-metadata dd {
  margin: 0;
  overflow-wrap: anywhere;
}
.ssh-inventory .ssh-public-label {
  font-size: 12px;
  color: #71717a;
  font-weight: 500;
  margin: 0 0 8px;
}
.ssh-inventory .ssh-public-key {
  border: 0;
  background: #f8fafc;
  border-radius: 6px;
  padding: 16px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-all;
  user-select: text;
  font-size: 12px;
  line-height: 1.8;
  margin: 0;
}
.ssh-inventory .ssh-diagnostics {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  color: #71717a;
  margin-top: 16px;
}
.ssh-inventory .ssh-diagnostics summary {
  cursor: pointer;
  font-size: 12px;
}
.ssh-inventory .ssh-diagnostic {
  padding-top: 12px;
  overflow-wrap: anywhere;
}
.ssh-inventory .ssh-diagnostic p {
  margin: 6px 0;
}
.ssh-inventory .ssh-source {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  padding: 12px 0;
  border-bottom: 1px solid #f4f4f5;
}
.ssh-inventory .ssh-source-links {
  margin-top: 20px;
}
.ssh-inventory .ssh-dismiss {
  float: right;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  margin-left: 12px;
}
@media (max-width: 767px) {
  .ssh-inventory .ssh-key-metadata {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .ssh-inventory .ssh-key-metadata dd {
    margin-bottom: 10px;
  }
}`],
})
export class PageKieraSshAccessComponent implements OnInit, OnDestroy {
    public data: any = { rows: [], clusters: [], summary: {} };
    public detail: any = null;
    public keyId: string = '';
    public clusterId: number = 0;
    public search: string = '';
    public source: string = '';
    public nodeFilter: number = 0;
    public accountFilter: string = '';
    public page: number = 1;
    public pageSize: number = 20;
    public loading: boolean = false;
    public error: string = '';
    public notice: string = '';
    public detailTab: string = 'nodes';
    public visibleFingerprints: Set<string> = new Set();
    public connectionLogs: any = { rows: [], total: 0 };
    public logsPage: number = 1;
    public logsSearch: string = '';
    public includeAccountMatches: boolean = false;
    public logsLoading: boolean = false;
    public logsError: string = '';
    private logsRequest: number = 0;
    private routerSub: Subscription;
    private requestId: number = 0;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }
    public async ngOnInit() {
        await this.service.init();
        await this.routeChanged();
        this.routerSub = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) this.routeChanged();
        });
    }
    public ngOnDestroy() { this.requestId++; this.routerSub?.unsubscribe(); }
    public t(ko: string, en: string) { return String(this.service.lang.get() || 'ko').startsWith('en') ? en : ko; }
    private async routeChanged() {
        const url = new URL(location.href);
        this.keyId = decodeURIComponent(url.pathname.split('/ssh-access')[1]?.replace(/^\//, '').split('/')[0] || '');
        this.clusterId = Number(url.searchParams.get('cluster') || 0);
        this.search = url.searchParams.get('q') || '';
        this.source = url.searchParams.get('type') || '';
        this.nodeFilter = Number(url.searchParams.get('node') || 0);
        this.accountFilter = url.searchParams.get('user') || '';
        this.detailTab = 'nodes'; this.page = 1; this.logsPage = 1; this.logsRequest++; this.connectionLogs = { rows: [], total: 0 };
        await this.load();
    }
    public async load() {
        const request = ++this.requestId;
        this.visibleFingerprints.clear();
        this.loading = true; this.error = ''; this.notice = ''; this.detail = null;
        await this.service.render();
        try {
            const response = await wiz.call(this.keyId ? 'key_detail' : 'key_list', { key_id: this.keyId });
            if (request !== this.requestId) return;
            if (response.code !== 200) throw new Error(response.data?.message || this.t('키 목록을 불러오지 못했습니다.', 'Could not load SSH keys.'));
            if (this.keyId) this.detail = response.data; else this.data = response.data;
        } catch (e) { if (request === this.requestId) this.error = String(e?.message || e); }
        finally { if (request === this.requestId) { this.loading = false; await this.service.render(); } }
    }
    public async toggleFingerprint(keyId: string) {
        if (this.visibleFingerprints.has(keyId)) this.visibleFingerprints.delete(keyId);
        else this.visibleFingerprints.add(keyId);
        await this.service.render();
    }
    public rows() {
        const needle = this.search.trim().toLowerCase();
        return (this.data.rows || []).filter((row: any) =>
            (!this.clusterId || row.clusters.some((c: any) => Number(c.id) === Number(this.clusterId))) &&
            (!this.source || row.types.includes(this.source)) &&
            (!this.nodeFilter && !this.accountFilter || row.sources.some((s: any) => s.type === 'authorized' &&
                (!this.nodeFilter || Number(s.id) === this.nodeFilter) && (!this.accountFilter || s.name.startsWith(this.accountFilter + '@')))) &&
            (!needle || [row.name, row.fingerprint, row.algorithm, ...row.clusters.map((c: any) => c.name),
                ...row.sources.map((s: any) => s.name)].some((v: any) => String(v || '').toLowerCase().includes(needle))));
    }
    public pageCount() { return Math.max(1, Math.ceil(this.rows().length / this.pageSize)); }
    public paged() { return this.rows().slice((this.page - 1) * this.pageSize, this.page * this.pageSize); }
    public async filtersChanged() { this.page = 1; await this.service.render(); }
    public async clearFilters() {
        this.clusterId = 0; this.search = ''; this.source = ''; this.nodeFilter = 0; this.accountFilter = '';
        await this.filtersChanged();
    }
    public async turn(delta: number) { this.page = Math.max(1, this.page + delta); await this.service.render(); }
    private query() {
        const query = new URLSearchParams();
        if (this.clusterId) query.set('cluster', String(this.clusterId));
        if (this.search) query.set('q', this.search);
        if (this.source) query.set('type', this.source);
        if (this.nodeFilter) query.set('node', String(this.nodeFilter));
        if (this.accountFilter) query.set('user', this.accountFilter);
        return query.toString() ? '?' + query.toString() : '';
    }
    public listLink() { return '/kiera/ssh-access' + this.query(); }
    public keyLink(row: any) { return '/kiera/ssh-access/' + row.id + this.query(); }
    public navigate(event: Event, url: string) {
        if ((event as MouseEvent).ctrlKey || (event as MouseEvent).metaKey || (event as MouseEvent).shiftKey) return;
        event.preventDefault(); this.service.href(url);
    }
    public typeLabel(type: string) {
        const labels: any = { cluster: ['클러스터 관리 키', 'Cluster management'], registered: ['등록 키', 'Registered key'],
            server: ['서버 기본 키', 'Server default'], authorized: ['노드 등록 키', 'Node authorized key'] };
        return labels[type] ? this.t(labels[type][0], labels[type][1]) : type;
    }
    public clusterNames(row: any) { return row.clusters.map((c: any) => c.name).join(', ') || '—'; }
    public async changeTab(tab: string) { this.detailTab = tab; if (tab === 'logs') await this.loadConnectionLogs(); await this.service.render(); }
    public async loadConnectionLogs() {
        const request = ++this.logsRequest, keyId = this.keyId;
        this.logsLoading = true; this.logsError = '';
        try {
            const response = await wiz.call('key_logs', { key_id: keyId, page: this.logsPage, dump: 25, search: this.logsSearch, include_account_matches: this.includeAccountMatches });
            if (request !== this.logsRequest || keyId !== this.keyId) return;
            if (response.code !== 200) throw new Error(response.data?.message || this.t('접속 로그를 불러오지 못했습니다.', 'Could not load connection logs.'));
            this.connectionLogs = response.data;
        } catch (error: any) { if (request === this.logsRequest) { this.logsError = error.message; this.connectionLogs = { rows: [], total: 0 }; } }
        finally { if (request === this.logsRequest) { this.logsLoading = false; await this.service.render(); } }
    }
    public async logTurn(delta: number) { this.logsPage = Math.max(1, this.logsPage + delta); await this.loadConnectionLogs(); }
    public failures() { return (this.detail?.nodes || []).filter((node: any) => node.collection_error); }
    public nodeState(node: any) {
        if (node.collection_error) return this.t('최근 수집 실패', 'Last collection failed');
        if (!node.checked_at) return this.t('미확인', 'Not checked');
        if (node.observed) return this.t('공개키 확인됨', 'Public key observed');
        return this.t('수집 목록에 없음', 'Absent from collected keys');
    }
    public formatDate(value: any) { return value ? new Date(value).toLocaleString(this.t('ko-KR', 'en-US')) : '—'; }
    public async copyPublicKey() {
        try {
            await navigator.clipboard.writeText(this.detail.public_key);
            this.notice = this.t('공개키를 복사했습니다.', 'Public key copied.');
        } catch (e) { this.notice = this.t('복사하지 못했습니다. 공개키 텍스트를 선택해 복사하세요.', 'Could not copy. Select the public key text to copy it.'); }
        await this.service.render();
    }
}

export default PageKieraSshAccessComponent;
